/* © CNES */
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { useContext, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useGetProcessings } from '../../../api/processings/processings';
import { ConfigContext } from '../../../context/ConfigContext';
import { Processing } from '../../../models/Processing';
import './JobsCompletedToast.scss';
/**
 * Toast to display link to processings view when a job is completed (sucessful or failed)
 * @returns Element.
 */
export const JobsCompletedToast = () => {
  const context = useContext(ConfigContext);
  const navigate = useNavigate();
  const [jobsRunning, setJobsRunning] = useState<string[]>([]);
  const { data } = useGetProcessings(
    {
      isEnabled: !!context.userLoggedIn.email,
    },
    navigate,
    context.setError400
  );
  const toast = useRef<Toast>(null);
  /**
   * Content of the Toast message.
   */
  const detailsContent = (
    <>
      <div>
        <span>One of your running processes is complete.</span>
        <div className="RedirectionContainer">
          <Button
            className="RedirectionButton"
            label="Click here"
            text
            onClick={(e: React.MouseEvent) => navigate('/MyData/processings')}
          />{' '}
          <span>to visit the processings list.</span>
        </div>
      </div>
    </>
  );

  /**
   * Display message for toast.
   */
  const messageDisplay = () => {
    toast.current?.replace({
      severity: 'success',
      summary: 'Processing complete',
      detail: detailsContent,
      life: 5000,
    });
  };

  /**
   * Evaluate if jobs swap between running to successful/failed status to trigger toast display.
   */
  useEffect(() => {
    let hasJobCompleted = false;
    data?.jobs?.forEach((job: Processing) => {
      if (job.status === 'running' && !jobsRunning.includes(job.jobID)) {
        setJobsRunning([...jobsRunning, job.jobID]);
      }

      if (
        (job.status === 'successful' || job.status === 'failed') &&
        jobsRunning.includes(job.jobID)
      ) {
        hasJobCompleted = true;
        jobsRunning.splice(
          jobsRunning.findIndex((jobID) => jobID === job.jobID),
          1
        );
        setJobsRunning(jobsRunning);
      }
    });

    if (data && hasJobCompleted) {
      messageDisplay();
    }

    // eslint-disable-next-line
  }, [data]);

  return <Toast ref={toast} position="top-center" />;
};
